import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import SingleImageInput from "components/SingleImageInput";
import Placeholder from "components/Placeholder";
import { IconPencil, IconTeam, IconUser } from "components/Icon";

import "./_style.scss";

const iconSize = 16;

const AvatarInput = ({
  value,
  initialValue,
  alt,
  isInvalid,
  cropRatio,
  placeholder,
  onChange,
  onChangeComplete,
}) => {
  const renderPlaceholder = (placeholder) => {
    if (placeholder.toLowerCase().includes("team logo")) {
      return <IconTeam fill="#fff" height={64} />;
    }
    return <IconUser fill="#fff" height={56} />;
  };

  return (
    <div className={classNames("avatar-input", { "--isInvalid": isInvalid })}>
      <SingleImageInput
        value={value}
        isInvalid={isInvalid}
        initialValue={initialValue}
        alt={alt}
        cropRatio={cropRatio}
        onChange={onChange}
        imageWidth={140}
        imageHeight={140}
        onChangeComplete={onChangeComplete}
        placeholder={
          placeholder && (
            <Placeholder text="Upload a profile picture" look="avatar">
              {renderPlaceholder(placeholder)}
            </Placeholder>
          )
        }
      >
        {/* IconPencil trigger */}
        <div className="avatar-input__image-selector">
          <div className="avatar-input__update">
            <IconPencil label="Edit avatar" width={iconSize} />
          </div>
        </div>
      </SingleImageInput>
    </div>
  );
};

AvatarInput.propTypes = {
  value: PropTypes.string,
  initialValue: PropTypes.string,
  alt: PropTypes.string,
  isInvalid: PropTypes.bool,
  cropRatio: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onChangeComplete: PropTypes.func,
};

export default AvatarInput;
